import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const shopApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/shop",
      params,
    }),
  findOne: (shopId: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/shop/${shopId}`,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/shop",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/shop/${id}`,
      method: "patch",
      data,
    }),

  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/shop/${id}`,
      method: "delete",
    }),

  suspend: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/shop/${id}/suspend`,
      method: "patch",
      data,
    }),

  approve: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/shop/${id}/approve`,
      method: "patch",
      data,
    }),

  checkUsername: (data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/shop/check/username`,
      method: "post",
      data,
    }),

  unSuspend: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/shop/${id}/un-suspend`,
      method: "delete",
    }),

  updateAccount: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/shop/${id}/account`,
      data,
      method: "patch",
    }),
};
